<template>
  <div class="program-tile" :class="className">
    <div class="inner">
      <img :src="imageUrl" :alt="`Cover image for ${title}`" />
      <h3>{{ title }}</h3>
    </div>
  </div>
</template>

<style lang="less" scoped>
.program-tile {
  position: relative;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    border-radius: 15px;
    object-fit: cover;
  }

  &.new-style {
    h3 {
      font-size: 1.1em;
      color: white;
      font-weight: bold;
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }

  &.old-style {
    &:before {
      content: "";
      margin-top: 108%;
      display: block;
    }

    .inner {
      top: 0;
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
    }

    h3 {
      padding: 15px;
      overflow-wrap: break-word;
      color: white;
      text-transform: none;
      font-weight: bold;
      position: absolute;
      top: 0;
      line-height: 110%;
      text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15);
      font-size: 1.8em;
      width: 100%;
    }
  }
}
</style>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["title", "image"],
  computed: {
    newStyle() {
      return this.currentEdition.enable_program_library_view;
    },
    className() {
      return this.newStyle ? "new-style" : "old-style";
    },
    imageUrl() {
      if (this.image) {
        const height = this.newStyle ? 422 : 350;
        return `https://res.cloudinary.com/nomadic/image/fetch/w_325,h_${height},c_fill,f_auto,q_60/${encodeURIComponent(
          this.image
        )}`;
      }
    },
    ...mapGetters(["currentEdition"]),
  },
};
</script>
